// api/bulkVerificationApi.js
// Central place for bulk-verification endpoint URLs + auth header, so
// FileUpload.jsx and BulkResultPage.jsx don't drift out of sync.

export const API_BULK_BASE = 'https://api.app.exellius.com/api/bounce';

export const API_ENDPOINT_BULK_UPLOAD = `${API_BULK_BASE}/bulkUpload`;
export const API_ENDPOINT_BULK_FILES = `${API_BULK_BASE}/bulk/account/files`;

export const getBulkResultEndpoint = (id) => `${API_BULK_BASE}/bulk/result/${id}`;
export const getBulkDownloadEndpoint = (id) => `${API_BULK_BASE}/bulk/download/${id}`;

export const authHeaders = () => {
  const token = sessionStorage.getItem('access_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const bulkStatusColor = (status) => {
  switch (status) {
    case 'completed':
      return 'green';
    case 'processing':
      return 'blue';
    case 'pending':
      return 'gold';
    case 'processing_upload':
      return 'geekblue';
    case 'failed':
      return 'red';
    default:
      return 'default';
  }
};

export const isTerminalBulkStatus = (status) => status === 'completed' || status === 'failed';